<template>
    <div>
        <router-view v-if="$route.name === 'Login'" />
        <!-- 아래 block만 헤더와 lnb 포함: -->
        <div v-else class="container">
<!--            <Lnb />-->
            <Lnb :jwtToken="jwtToken" />
            <div class="wrap">
                <Header :title="title" @logout="logout"/>
                <div class="cont">
                    <router-view />
                </div>
            </div>
        </div>
        <ModalManager />
    </div>
</template>


<script>
import Header from './components/common/Header.vue'
import Lnb from './components/common/Lnb.vue'
import ModalManager from './components/modals/ModalManager.vue'
import api from '@/api'
import { useAuthStore } from '@/stores/auth';

export default {
    name: 'App',
    components: {
        Header,
        Lnb,
        ModalManager
    },
    data() {
        return {
            title: '',
            subtitle: '',
            jwtToken: '',
            logoutTimeoutId: null

        }
    },
    watch: {
        jwtToken(newToken) {
            if (newToken) {
                // 토큰 변경 시 localStorage 저장 및 axios 헤더 설정
                localStorage.setItem('jwtToken', newToken);
                api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            } else {
                // 토큰 삭제 시 localStorage 삭제, axios 헤더 제거, 타이머 클리어
                localStorage.removeItem('jwtToken');
                delete api.defaults.headers.common['Authorization'];
                this.clearLogoutTimer();
            }
        },
        "$route"(to) {
            this.title = to.meta.title || "";
        }
    },
    created() {
        this.title = this.$route.meta.title || ""
        // 앱 로드 시 localStorage에서 토큰 불러오기
        const token = localStorage.getItem('jwtToken') || ''
        this.jwtToken = token

        if (token) {
            // axios 인스턴스에 토큰 헤더 설정
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`

        }
    },
    methods: {
        clearLogoutTimer() {
            if (this.logoutTimeoutId) {
                clearTimeout(this.logoutTimeoutId)
                this.logoutTimeoutId = null
            }
        },
        logout() {
            useAuthStore().logout()
        }
    }

}
</script>